import axios from 'axios'

// You can use your own logic to set your local or production domain
const baseDomain = process.env.VUE_APP_API_URL
// The base URL is empty this time due we are using the jsonplaceholder API
const baseURL = `${baseDomain}/sale/api/v1`

const loginURL = process.env.VUE_APP_MANAGER_URL

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Expose-Headers': '*',
}

const $axios = axios.create({
  baseURL: baseURL,
  headers: headers,
  withCredentials: true,
  responseType: 'json',
})

$axios.interceptors.request.use(request => {
  return request
})

$axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 401) {
      window.location.href = `${loginURL}/login`
    } else {
      return Promise.reject(error)
    }
  },
)

export default $axios
